import axios from '../../utils/axios';
import CRUD from './crud'

const tournamentMedia = new CRUD('tournament-media', 'superior-judge')

export default Object.assign(
    tournamentMedia,
    {
        reducers: {
            ...tournamentMedia.reducers
        },
    }
)
